 import css from './style.scss'
 import "owl.carousel";
 import "./modules/ny-header/ny-header";
 import "./modules/ny-stars/ny-stars";
 import "./modules/ny-horoscope/ny-horoscope";
 import "./modules/ny-fashion/ny-fashion";
 import "./modules/ny-presents/ny-presents";
 import "./modules/ny-recipe/ny-recipe";
 import "./modules/ny-afisha/ny-afisha";
